import { ListAlt, Note } from '@mui/icons-material'
import { Button, IconButton, Popover, Typography } from '@mui/material'
import { MRT_ColumnDef } from 'material-react-table'
import { useState } from 'react'

import MontoMonedaTexto from '../../../../base/components/PopoverMonto/MontoMonedaTexto'
import SimpleCard from '../../../../base/components/Template/Cards/SimpleCard'
import { RecetaProp } from '../../interfaces'

export const recetaColumns: MRT_ColumnDef<RecetaProp>[] = [
  {
    accessorKey: 'numeroReceta',
    header: '#',
    enableColumnFilter: false,
    enableSorting: false,
    enableEditing: false,
    enableHiding: false,
    enableResizing: false,
    enableGlobalFilter: false,
    enableColumnActions: false,
    size: 20,
  },
  {
    accessorKey: 'nombreReceta',
    header: 'Receta',
    enableColumnActions: false,
    enableSorting: false,
    enableGlobalFilter: false,
    size: 150,
  },
  {
    accessorKey: 'descripcion',
    header: 'Descripción',
    enableColumnActions: false,
    enableSorting: false,
    enableGlobalFilter: false,
    size: 200,
  },
  {
    accessorKey: 'rendimiento',
    header: 'Rendimiento %',
    enableColumnActions: false,
    enableSorting: false,
    enableGlobalFilter: false,
    enableResizing: false,
    muiTableBodyCellProps: {
      align: 'right',
    },
    Cell: ({ row }) => {
      const { rendimiento } = row.original
      return <MontoMonedaTexto id={`rendimiento`} monto={rendimiento ?? 0} sigla={'%'} />
    },
    size: 130,
  },
  {
    accessorKey: 'tiempoEstimado',
    header: 'Tiempo Estimado',
    enableColumnActions: false,
    enableSorting: false,
    enableGlobalFilter: false,
    enableResizing: false,
    muiTableBodyCellProps: {
      align: 'right',
    },
    Cell: ({ row }) => {
      const { tiempoEstimado } = row.original
      return (
        <MontoMonedaTexto
          id={`tiempoEstimado`}
          monto={tiempoEstimado ?? 0}
          sigla={'hrs'}
        />
      )
    },
    size: 130,
  },
  {
    accessorKey: 'productoArticulo',
    header: 'Producto',
    enableColumnActions: false,
    enableSorting: false,
    enableGlobalFilter: false,
    enableResizing: false,
    muiTableBodyCellProps: {
      align: 'left',
    },
    Cell: ({ row }) => {
      const { articulo } = row.original.producto
      return (
        <Typography>
          <strong>{articulo?.nombreArticulo || 'N/A'}</strong>
        </Typography>
      )
    },
  },
  {
    accessorKey: 'productoCantidadUnidad',
    header: 'Cantidad',
    enableColumnActions: false,
    enableSorting: false,
    enableGlobalFilter: false,
    enableResizing: false,
    Cell: ({ row }) => {
      const {
        cantidad,
        //@ts-ignore
        articuloUnidadMedida: { nombreUnidadMedida },
      } = row.original.producto
      return (
        <MontoMonedaTexto
          id={`tiempoEstimado`}
          monto={cantidad ?? 0}
          sigla={nombreUnidadMedida}
        />
      )
    },
  },
  {
    accessorKey: 'acciones',
    header: 'Notas / Instru',
    enableColumnFilter: false,
    enableSorting: false,
    enableEditing: false,
    enableHiding: false,
    enableResizing: false,
    enableGlobalFilter: false,
    enableColumnActions: false,
    size: 100,
    Cell: ({ row }) => {
      const [anchorNota, setAnchorNota] = useState<HTMLButtonElement | null>(null)
      const [anchorInstrucciones, setAnchorInstrucciones] =
        useState<HTMLButtonElement | null>(null)

      const openNota = Boolean(anchorNota)
      const openInstrucciones = Boolean(anchorInstrucciones)

      const idPopoverNota = openNota ? `popover-receta-nota-${row.id}` : undefined
      const idPopoverInstrucciones = openInstrucciones
        ? `popover-receta-instrucciones-${row.id}`
        : undefined

      return (
        <>
          <IconButton
            onClick={(event) => setAnchorNota(event.currentTarget)}
            aria-describedby={idPopoverNota}
            disabled={!row.original.nota}
            size={'small'}
            color="primary"
          >
            <Note />
          </IconButton>
          <Popover
            id={idPopoverNota}
            open={openNota}
            anchorEl={anchorNota}
            onClose={() => setAnchorNota(null)}
          >
            <SimpleCard sx={{ width: 300, maxWidth: 300, maxHeight: 300 }}>
              <Typography>{row.original.nota}</Typography>
              <Button
                onClick={() => setAnchorNota(null)}
                color="error"
                sx={{ display: 'block', margin: '0 auto' }}
              >
                Cerrar
              </Button>
            </SimpleCard>
          </Popover>

          <IconButton
            onClick={(event) => setAnchorInstrucciones(event.currentTarget)}
            aria-describedby={idPopoverInstrucciones}
            disabled={!row.original.instrucciones}
            size={'small'}
            color="primary"
          >
            <ListAlt />
          </IconButton>
          <Popover
            id={idPopoverInstrucciones}
            open={openInstrucciones}
            anchorEl={anchorInstrucciones}
            onClose={() => setAnchorInstrucciones(null)}
          >
            <SimpleCard sx={{ width: 300, maxWidth: 300, maxHeight: 300 }}>
              <Typography
                dangerouslySetInnerHTML={{ __html: row.original.instrucciones }}
              />
              <Button
                onClick={() => setAnchorInstrucciones(null)}
                color="error"
                sx={{ display: 'block', margin: '0 auto' }}
              >
                Cerrar
              </Button>
            </SimpleCard>
          </Popover>
        </>
      )
    },
  },
]
